module.exports = __webpack_public_path__ + "img/202403_01.479d9a58.jpg";